import { OnInit, Component, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NotificationCategory } from './notification-category.model';
import { SessionService } from '../../../../app/shared/session.service';
import { SignalRService } from './signal-r.service';
//import { SharedModule } from '../../../shared/shared.module';

const sessionStorageKey = 'NotificationSettings';

@Component({
	// standalone: true,
	selector: 'notification-layout',
	templateUrl: 'notification-layout.component.html',
	encapsulation: ViewEncapsulation.None,
	// imports: [SharedModule]
})
export class NotificationLayoutComponent implements OnInit {
	@Input() notificationCategories: NotificationCategory[];
	@Output() closeNotifications = new EventEmitter();
	public nightMode = true;
	public groupByCategory = true;
    public selectedTab = 'Active';
    public activeView = true;

	constructor(
		private hubConnectionService: SignalRService,
		private sessionService: SessionService,
	) {}

	ngOnInit(): void {
		const settings = this.sessionService.fetch(sessionStorageKey);
		if (!!settings) {
			this.nightMode = settings.nightMode;
			this.groupByCategory = settings.groupByCategory;
        }
        this.selectedTab = 'Active';
        this.onTabChange();
	}
	get dismissedCategories(): NotificationCategory[]{
		return this.hubConnectionService.getDismissedCategories();
	}
	get isNotificationFetched(){
		return this.hubConnectionService.notificationFetched;
	}

	groupByCategoryChange(): void {
		this.hubConnectionService.setGroupByCategory(this.groupByCategory);
		this.hubConnectionService.fetchNotifications();
		this.sessionService.store(sessionStorageKey, {nightMode: this.nightMode, groupByCategory: this.groupByCategory});
	}

	nightModeChange(): void {
		this.sessionService.store(sessionStorageKey, {nightMode: this.nightMode, groupByCategory: this.groupByCategory});
	}
	public onTabSelect(selectedTab: any): void {
		this.selectedTab = selectedTab.title;
		this.onTabChange();
	}

	onTabChange() {
		switch (this.selectedTab) {
			case 'Active':
                this.hubConnectionService.setViewType(true);
                this.activeView = true;
			break;
			case 'Dismissed':
                this.hubConnectionService.setViewType(false);
				this.activeView = false;
				
				
			break;
        }
        this.hubConnectionService.fetchNotifications();
	}
}
